<template>
	<AuthedLayout ref="resourcesPage">
		<div class="flex flex-col">
			<p class="dashboard-title">Resources</p>
			<LoadingSpinner v-if="isLoading" />
			<span v-if="!isLoading && resourceCategories.length === 0" class="mx-auto mt-8">There are currently no resources available to you.</span>
			<div class="grid grid-cols-2 w-full gap-6" style="">
				<ResourceCategoryPanel class="h-full" v-for="category in resourceCategories" :key="category.id" :id="category.id" :disabled="false" :ref="category.id"
												:category="category" @category-expanded="categoryExpanded(category.id)" />
			</div>
		</div>
	</AuthedLayout>
</template>

<script setup lang="js">
import AuthedLayout from '@/layouts/AuthedLayout.vue'
import ResourceCategoryPanel from '@/components/Resources/ResourceCategoryPanel.vue'
import { onMounted, ref } from 'vue'
import { resourcesApi } from '@/api/Organizations/Resources/ResourcesApi.js'
import LoadingSpinner from '@/components/Spinners/LoadingSpinner.vue'

const resourcesPage = ref(null)
const resourceCategories = ref([])
const isLoading = ref(false)

onMounted(() => {
	isLoading.value = true
	resourcesApi.list(false, (response) => {
		resourceCategories.value = response['data'].filter((category) => {
			return category.subcategories.length > 0 && category.subcategories.some((subcategory) => {
				return subcategory.resources.length > 0
			})
		})
		isLoading.value = false
	}, (e) => {
		console.log(e)
		isLoading.value = false
	})
})

function categoryExpanded(panelName)
{
	const panel = document.getElementById(panelName)
	if (panel)
	{
		setTimeout(() =>
		{
			panel.scrollIntoView({
				behavior: 'smooth'
			})
		}, 150) // Small delay to let the view settle after changing visibility
	}
}

</script>
